<template>
  <div>
    <div class="p-2 flex-shrink-0 bg-gray-300 mb-1">
      <note-viewer :note="note" :store-note-url="storeNoteUrl"></note-viewer>
    </div>
    <chat
        class="flex-grow-1"
        :index-url="indexUrl"
        :store-url="storeUrl"
        :conversation="conversation"
        :index-media-url="indexMediaUrl"
        :can-create-media="canCreateMedia"
        :store-media-url="storeMediaUrl"
        :can-send-message="canSendMessage"
        :types="types"
    ></chat>
  </div>
</template>

<script>
import NoteViewer from "../../../conversation-list/note-viewer";

export default {
  components: {
    NoteViewer,
  },

  props: {
    conversation: Object,
    indexMediaUrl: String,
    canCreateMedia: {
      type: Boolean,
      default: false,
    },
    storeMediaUrl: String,
    canSendMessage: {
      type: Boolean,
      default: false,
    },
    types: Object,
  },

  computed: {
    /**
     * @return {string}
     */
    indexUrl() {
      return _.get(this.conversation, 'message_index_url', '');
    },

    /**
     * @return {string}
     */
    storeUrl() {
      return _.get(this.conversation, 'message_store_url', '');
    },

    /**
     * @return {Object}
     */
    note() {
      return _.get(this.conversation, 'note', null);
    },

    /**
     * @return {string}
     */
    storeNoteUrl() {
      return _.get(this.conversation, 'storeNoteUrl', '');
    },
  },
}
</script>
